import { React, useEffect, useState, useRef, forwardRef } from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Button, Card, CardContent, Grid, Stack, Typography, Chip, Avatar, Dialog, DialogTitle, DialogContent, DialogContentText, Slide, DialogActions, Snackbar, Alert } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { Star, PlayArrow, Save } from "@mui/icons-material";
import { LocalizationProvider, StaticDateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import CheckIcon from '@mui/icons-material/Check';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import LoginModal from "../../auth/login";
import { useMediaQuery, useTheme, TextField } from '@mui/material';
import { MobileDatePicker, DesktopDatePicker } from '@mui/x-date-pickers';
import { CreateMeeting, GetPrice, GetTimeSlot, RequestMeeting, GetPriceDrawer } from "../../services";
import { useAuth } from "../../context/AuthContext";
import CircularProgress from '@mui/material/CircularProgress';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RightSwipeableDrawer(props) {
    // const [open, setOpen] = useState(props?.open || false);
    const { open, setOpen } = props;
    const [data, setData] = useState(props?.data || {});
    const [Timedata, seTimedata] = useState([]);
    const [startdate, setStartdate] = useState("");
    const [enddate, setEnddate] = useState("");
    const [mentorid, setmentorid] = useState(data.id);
    const [ordernow, setordernow] = useState(false);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [SelectedStudentDate, setSelectedStudentDate] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState({
        id: "",
        time: "",
    });
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState({ date: false, description: false });
    const [opendialog, setOpendialog] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false); // or true if user is logged in
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [packages, setpackages] = useState([]);
    const [Time, setTime] = useState([]);
    const [timepayload, settimepayload] = useState({
        Mode: "",
        duration: "",
        price_id: "25"
    })
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const { authdetails } = useAuth();
    const datePickerRef = useRef(null);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const handleSnackbarClose = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };
    // const Time = [
    //     { time: "10:50 AM" },
    //     { time: "11:30 AM" },
    //     { time: "12:15 PM" },
    //     { time: "01:45 PM" },
    //     { time: "03:00 PM" },
    //     { time: "04:20 PM" }
    // ];
    // const packages = [
    //     { "type": "Chat 30 Min", "price": 20 },
    //     { "type": "Video 30 Min", "price": 35 },
    //     { "type": "Video 60 Min", "price": 60 }
    // ] 
    // if (mentorid) {
    const fetchData = async (id) => {
        try {

            // const id = data.id
            const res = await GetPriceDrawer(id);
            setpackages(res.data);
        } catch (err) {
            console.error('Error fetching mentors:', err);
        }
    };


    const toggleDrawer = (isOpen) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setOpen(isOpen);
        if (!isOpen) {
            setSelectedDate(null); // Reset the selectedDate when drawer closes
            setShowDatePicker(false)
            setSelectedSlot(null)
        }

    };
    const GetMentorTimeSlot = async (id, formatted, timepayload, stdate, enddate) => {
        try {
            const mentor_id = id || data?.id;
            const date = formatted || null;

            const response = await GetTimeSlot(mentor_id, date, "25", null, stdate, enddate);
            if (response.status === 200) {
                const timeSlotList = response?.data?.data?.map(item => ({
                    id: item.id,
                    slot_time: item?.hour?.slot_time?.slice(0, 5) || "N/A", // ensures HH:mm
                    date: item.date,
                    refmentorid: item.refmentorid,
                }));

                setTime(timeSlotList);
                seTimedata(response?.data);
            }
        } catch (err) {
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || "Unable to fetch time slots. Please try again.",
                severity: "error",
            });
        }
    };



    useEffect(() => {
        const isLoggedIn = !!localStorage.getItem('token');
        setIsLoggedIn(isLoggedIn);
        const start = dayjs();
        const end = start.add(7, 'day');

        setStartdate(start.format('YYYY-MM-DD'));
        setEnddate(end.format('YYYY-MM-DD'));
        if (ordernow) {
            GetMentorTimeSlot();
        }

        const newData = props.data;
        if (props.open !== undefined) {
            setOpen(props.open);
        }
        if (newData) {
            setData(newData);
            setmentorid(newData.id);
            fetchData(newData.id); // pass mentor ID explicitly
        }

        if (!open) {
            setSelectedDate(null);
        }

    }, [props.open, props.data, data]);


    const drawerList = (data) => {
        const handleOrderNow = () => {

            setShowDatePicker(true);
            setSelectedDate(null);

            // console.log("Show Date Picker:", showDatePicker); // Debugging

            setTimeout(() => {
                if (datePickerRef.current) {
                    datePickerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 200);
        };


        const handleDateChange = (newValue) => {
            setSelectedDate(newValue);
            // console.log("selectedDate", selectedDate)
        };
        const RequestTimeslot = async (selectedDate) => {
            const hasDateError = !selectedDate;
            const hasDescriptionError = !description.trim();

            setErrors({
                date: hasDateError,
                description: hasDescriptionError
            });

            if (hasDateError || hasDescriptionError) return;
            const date = selectedDate.format('YYYY-MM-DD');
            const time = selectedDate.format('HH:mm:ss');
            const refmentorid = data?.id;
            const refuserid = authdetails?.id;

            try {

                const payload = {
                    refmentorid,
                    refuserid,
                    date,
                    time,
                    description
                };
                // console.log("payload:", payload);
                const response = await RequestMeeting(payload); // Replace with your actual API function
                if (response.status === 200) {
                    setOpendialog(true);
                    setSelectedSlot(null)
                    setDescription("")
                }
            } catch (error) {
                console.error("Error submitting time slot", error);
            }



        }


        // Function to confirm and log selected date
        const handleConfirmDate = () => {
            if (selectedDate) {
                // console.log("Confirmed Date:", dayjs(selectedDate).format("MMMM D, YYYY h:mm A"));
                setShowDatePicker(false); // Hide picker after confirming
                // Open the dialog
            }
            // openpop(selectedDate);
        };

        const handleClose = () => {
            setOpendialog(false);
            setOpen(false)
            setSelectedDate(null);
            setShowDatePicker(false)
            setDescription("")
            setordernow(false)
            setSelectedStudentDate(null)
            setpackages(null)
            setmentorid("")
        };


        const handleOrderClick = (item) => {
            // console.log("item", item);

            setordernow(true);
            // const words = item?.label?.split(" ") || [];
            // const mode = words[0] || "";
            // const duration = words.length > 1 ? words.slice(1).join(" ") : item.duration?.toString() || "";
            setSelectedStudentDate(null)
            settimepayload({
                Mode: "vedio",
                duration: "60",
                price_id: "2500"
            });

            if (isLoggedIn) {
                handleOrderNow();


                GetMentorTimeSlot(mentorid, null, null, startdate, enddate)
            } else {
                navigate("/login");
                // handleClose()
            }
        };
        // console.log("settimepayload", timepayload)
        const handleTimeDateChange = (newDate) => {
            // console.log("newDate",newDate);

            setSelectedStudentDate(newDate);
            // If you want to format before sending to API:
            const formatted = dayjs(newDate).format("YYYY-MM-DD");
            // console.log("Formatted Date for API:", formatted);
            const mentor_id = data?.id;
            setSelectedDate(formatted)
            GetMentorTimeSlot(mentor_id, formatted, null)
            // you can now pass this formatted value in your API call
        };

        const handleSubmit = async () => {
            if (!selectedSlot) {
                alert("Please select a time slot");
                return;
            }
            setLoading(true);
            try {
                const refmentorid = data?.id;
                const refuserid = authdetails?.id;
                const date = selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
                const time_mapping_id = selectedSlot?.id;
                const price = timepayload.price_id;
                const payload = {
                    refmentorid,
                    refuserid,
                    time_mapping_id,
                    price
                };
                // console.log("payload:", payload);
                const response = await CreateMeeting(payload); // Replace with your actual API function
                if (response.status === 200) {
                    setOpendialog(true);
                    setSelectedSlot(null)

                }
            } catch (error) {
                console.error("Error submitting time slot", error);
            }
            finally {
                setLoading(false); // Stop loader
            }
        };

        return (
            <Box
                sx={{
                    width: { xs: "100%", sm: "100%", md: 600, lg: 600, xl: 700 },
                    maxWidth: "90vw",
                    padding: { xs: 2, md: 4 },
                    overflowX: "hidden",
                    background: "aliceblue"
                }}
            >
                <Box sx={{ backgroundColor: "#bcdade", height: 150, position: "relative", borderRadius: "50px" }}>
                    <Avatar
                        src={data.profile}
                        sx={{
                            width: 100,
                            height: 100,
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            bottom: -50,
                            border: "4px solid white",
                        }}
                    />
                </Box>
                <Box sx={{ paddingTop: 6, textAlign: "center" }}>
                    <Typography variant="h5" fontWeight="bold">
                        {data.name}
                    </Typography>
                    <Typography color="textSecondary"> {data.area_of_study}</Typography>
                    <Typography color="primary">{data.college}</Typography>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ marginTop: 1 }}>
                        <Typography>{data.country_studied_in}</Typography>
                        <Star sx={{ color: "#FFD700" }} />
                        <Typography>{data.rating}.0</Typography>
                    </Stack>
                    {/* <Typography color="textSecondary">Active today • Usually responds in a few hours</Typography> */}
                    {/* <Stack direction="row" justifyContent="center" spacing={2} sx={{ marginTop: 2 }}>
                        <Button variant="contained" startIcon={<PlayArrow />}>
                            Play Intro
                        </Button>
                    </Stack> */}
                </Box>

                {/* Skills and Topics */}
                <Grid container spacing={2} sx={{ marginTop: 4 }}>
                    <Grid item xs={12} md={12}>
                        <Typography variant="h6">Language Spoken</Typography>
                        <Stack direction="row" flexWrap="wrap" spacing={1} sx={{ marginTop: 1 }}>

                            <Chip label={["null", null, undefined].includes(data.langauge_spoken1) ? "" : data.langauge_spoken1} />
                            <Chip label={["null", null, undefined].includes(data.langauge_spoken2) ? "" : data.langauge_spoken2} />
                            <Chip label={["null", null, undefined].includes(data.langauge_spoken3) ? "" : data.langauge_spoken3} />

                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant="h6">Expertise</Typography>
                        <Stack direction="row" flexWrap="wrap" spacing={1} sx={{ marginTop: 1 }}>
                            <Chip label={data.expertise} />
                        </Stack>
                    </Grid>
                </Grid>

                {/* About Section */}
                <Box sx={{ marginTop: 4 }}>
                    <Typography variant="h6">About</Typography>
                    <Typography variant="body2" color="textSecondary">
                        {data.about}
                    </Typography>
                </Box>

                {/* Pricing Cards */}
                <Grid container spacing={2} sx={{ marginTop: 4 }}>
                    {/* {packages && packages.map((item, index) => ( */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Card sx={{ backgroundColor: '#bcdade', textAlign: "center", padding: 2 }}>
                            <CardContent>
                                <Typography variant="h6">Video 60 min</Typography>
                                <Typography variant="h4" fontWeight="bold">₹ 2500</Typography>
                                <Button
                                    variant="contained"
                                    sx={{ marginTop: 2 }}
                                    onClick={() => handleOrderClick()}
                                >
                                    Book NOW
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                    {/* ))} */}
                </Grid>
                {showDatePicker && open && (
                    <Box ref={datePickerRef} sx={{ marginTop: 4 }} >
                        <Card sx={{ padding: "30px", marginBottom: "20px", background: "linear-gradient(to right, #0f9ba1, #8ee3a8)" }}>
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={2}
                                justifyContent="space-between"
                                flexWrap="wrap"
                                mt="15px"
                                mb="20px"
                            >
                                <Typography variant="h4" color="white">Select Time Slot</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ paddingRight: "10px" }}>
                                    {isMobile ? (
                                        <MobileDatePicker
                                            label="Select date"
                                            value={SelectedStudentDate}
                                            defaultValue={dayjs()}
                                            onChange={handleTimeDateChange}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    ) : (
                                        <DesktopDatePicker
                                            label="Select date"
                                            value={SelectedStudentDate}
                                            defaultValue={dayjs()}
                                            onChange={handleTimeDateChange}
                                            renderInput={(params) => <TextField {...params} />}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    variant: 'outlined',
                                                    error: false,
                                                    helperText: '',
                                                    sx: {
                                                        '& .MuiInputBase-root': {
                                                            background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                                                            borderRadius: '5px',
                                                            color: 'white',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'grey', // default border
                                                        },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'black',
                                                        },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'blue',
                                                        },
                                                        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'grey !important', // force grey even in error
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            color: 'white',
                                                        },
                                                        '& .Mui-error': {
                                                            color: 'white',
                                                        },
                                                    },
                                                },
                                                popper: {
                                                    placement: 'left-start',
                                                    sx: {
                                                        '& .MuiPaper-root': {
                                                            background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                                                            color: 'white',
                                                            borderRadius: 2,
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    )}
                                </LocalizationProvider>
                            </Box>
                            <Grid container spacing={6} marginBottom="10px">
                                <Grid container spacing={3} marginBottom="10px">
                                    {Time.length === 0 ? (
                                        <Grid item xs={12}>
                                            <Typography variant="h6" align="center" color="textSecondary">
                                                No data available
                                            </Typography>
                                        </Grid>
                                    ) : (
                                        Time.map((item, index) => {
                                            console.log("item", item);

                                            const isSelected = selectedSlot?.id === item.id;
                                            return (
                                                <Grid item key={item.id || index} sm={6} xs={12}>
                                                    <Card
                                                        onClick={() => setSelectedSlot({ id: item.id, time: item.slot_time })}
                                                        sx={{
                                                            width: "100%",
                                                            cursor: "pointer",
                                                            backgroundColor: isSelected ? "#1976d2" : "white",
                                                            color: isSelected ? "white" : "black",
                                                            border: "1px solid #1976d2",
                                                            transition: "all 0.3s ease-in-out",
                                                            textAlign: "center",
                                                            borderRadius: "20%"
                                                        }}
                                                    >
                                                        <Typography variant="h6" padding="10px">
                                                            <div>{item.slot_time}</div>
                                                            <span>{dayjs(item.date).format("DD-MM-YYYY")}</span>

                                                        </Typography>
                                                    </Card>
                                                </Grid>
                                            );
                                        })
                                    )}
                                </Grid>
                            </Grid>
                            <Box display="flex" justifyContent="flex-end">
                                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
                                    {loading ? 'Submitting...' : 'SUBMIT'}
                                </Button>
                            </Box>
                        </Card>
                        {/* <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: 2 }}>
                            <Typography variant="h4" sx={{ textAlign: "left", mb: 2 }}>Request</Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <StaticDateTimePicker
                                    orientation="landscape"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    onAccept={handleConfirmDate}
                                    slotProps={{
                                        actionBar: {
                                            actions: [],
                                        },
                                    }}
                                />
                            </LocalizationProvider>
<Box>
                            <TextField
                                id="filled-multiline-static"
                                label="Description"

                                multiline

                                rows={6}
                                variant="filled"
                                sx={{ flexGrow: 1, mt: 2 ,mb:2}}
                                fullWidth
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                error={errors.description}
                                helperText={errors.description ? "Description is required" : ""}
                            />
                                <Button 
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={() => RequestTimeslot(selectedDate)}
                                >
                                    SUBMIT
                                </Button>
                           
                            </Box>
                        </Box> */}

                        <Dialog
                            open={opendialog}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={handleClose}
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogContent sx={{ textAlign: 'center', py: 4, px: 3 }}>
                                <Box
                                    sx={{
                                        backgroundColor: '#8BC34A', // Green color
                                        borderRadius: '50%',
                                        width: 80,
                                        height: 80,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: '0 auto 20px',
                                    }}
                                >
                                    <CheckIcon sx={{ color: 'white', fontSize: 40 }} />
                                </Box>
                                <Typography variant="h4" component="h2" sx={{ mb: 2, fontWeight: 500, color: '#5f5f5f' }}>
                                    Awesome!
                                </Typography>

                                <Typography variant="h5" sx={{ mb: 4, color: '#757575' }}>
                                    Your booking has been confirmed.
                                    <br />
                                    Check your email for details.
                                </Typography>

                                {/* <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={onClose}
                                    sx={{
                                        backgroundColor: '#8BC34A',
                                        textTransform: 'none',
                                        py: 1.5,
                                        '&:hover': {
                                            backgroundColor: '#7CB342',
                                        }
                                    }}
                                >
                                    OK
                                </Button> */}

                            </DialogContent>
                        </Dialog>
                    </Box>
                )}
            </Box>
        );
    };
    const handleLoginSuccess = (success) => {
        if (success) {
            setIsLoggedIn(true);
            // window.location.reload();
            // You can perform more actions like redirect, fetch profile, etc.
        }
    };
    return (
        <>
            <SwipeableDrawer
                anchor="right"
                open={open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                sx={{
                    "& .MuiDrawer-paper": {
                        width: { xs: "100%", sm: "80%", md: 650, lg: 700, xl: 800 }, // Responsive drawer width
                        maxWidth: "100vw", // Prevents extra space
                        overflowX: "hidden", // Fixes horizontal scrolling issue
                    },
                }}
            >
                {drawerList(data)}
            </SwipeableDrawer>
            {/* <LoginModal open={loginModalOpen} onClose={() => setLoginModalOpen(false)} onLoginSuccess={handleLoginSuccess} /> */}
            {/* <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar> */}
        </>
    );
}
